/* Stylesheet */

.illustration_container {
  height: 100%;
  background: var(--ion-gradient-dark);

  .illustration {
    height: 100%;
    background: url("/assets/img/illustration.svg")
      no-repeat center;
  }
}
